// Textos de los anuncios por zona: informe de desequilibrio, borradores y
// plantillas. Se registran junto al resto de vocabularios en AppComponent.
export const locale = {
  lang: 'es',
  data: {
    ZONE_ADS: {
      ZONE: 'Zona',
      TARGET_ROLE: 'Dirigido a',
      STATUS_LABEL: 'Estado',
      BUDGET: 'Presupuesto',
      BUDGET_EUROS: 'Presupuesto (€)',
      DURATION: 'Duración',
      DURATION_DAYS: 'Duración (días)',
      DAYS: '{{count}} d',
      RADIUS_KM: 'Radio (km)',
      ADVANTAGE: 'Audiencia Advantage+ de Meta',
      ADVANTAGE_HINT: 'Meta puede ampliar la edad y los intereses para mejorar el rendimiento; la zona sigue siendo un límite.',
      ROUTINES: 'Rutinas',
      CREATED_AT: 'Creado',
      UPDATED_AT: 'Actualizada',
      ACTIONS: 'Acciones',
      OPEN: 'Abrir',
      OPEN_MAPS: 'Ver en Google Maps',
      NO_ZONE_LABEL: 'Sin nombre de zona',
      FILTER_ALL_STATUSES: 'Todos los estados',
      FILTER_ALL_ROLES: 'Todos los destinatarios',
      CLEAR_FILTERS: 'Limpiar filtros',
      PREVIOUS: 'Anterior',
      NEXT: 'Siguiente',
      RETRY: 'Reintentar',
      RELOAD: 'Recargar',
      LOADING: 'Cargando…',
      SHOW: 'Ver',
      HIDE: 'Ocultar',
      ACCEPT: 'Aceptar',
      CANCEL: 'Cancelar',
      CLOSE: 'Cerrar',
      SAVING: 'Guardando…',
      SAVE_CHANGES: 'Guardar cambios',
      REVIEW_FIELDS: 'Revisa los campos marcados.',
      ERROR_FORBIDDEN_ACTION: 'No tienes permiso para hacer esto.',

      ROLE: {
        driver: 'Conductores',
        rider: 'Pasajeros',
        both: 'Conductores y pasajeros',
      },
      STATUS: {
        draft: 'Borrador',
        approved: 'Aprobado',
        publishing: 'Publicando',
        publish_failed: 'Publicación fallida',
        published: 'Publicado',
        finished: 'Finalizado',
        rejected: 'Rechazado',
        meta_rejected: 'Rechazado por Meta',
      },

      VALIDATION: {
        REQUIRED: 'Este campo es obligatorio.',
        INTEGER: 'Tiene que ser un número entero.',
        RANGE: 'Tiene que estar entre {{min}} y {{max}}.',
        EURO_CENTS: 'Usa como mucho dos decimales.',
        MIN_BUDGET: 'El presupuesto mínimo es {{min}}.',
        HTTPS_URL: 'Tiene que ser una dirección https://.',
        MAX_LENGTH: 'Como mucho {{max}} caracteres.',
      },

      // error_type de trips-core; {{status}} es el estado actual del borrador.
      ERRORS: {
        zone_occupied: 'Esta zona ya tiene un borrador abierto para ese destinatario.',
        already_decided: 'El borrador ya no está pendiente de decisión: ahora está «{{status}}».',
        not_editable: 'El borrador ya no se puede editar: ahora está «{{status}}».',
        not_publishable: 'El borrador no se puede publicar: ahora está «{{status}}».',
        incomplete_draft: 'Al borrador le faltan datos para aprobarlo.',
        meta_not_configured: 'La publicación en Meta no está configurada.',
        template_in_use: 'Algún borrador usa esta plantilla.',
        not_found: 'El borrador ya no existe.',
        draft_in_meta: 'Este borrador llegó a Meta: no se puede eliminar, solo desactivarlo con «Rechazar».',
      },
      APPROVE_MISSING: {
        template_id: 'Una plantilla activa para el mismo destinatario que el borrador',
        zone_label: 'El nombre de la zona',
      },
      META_MISSING: {
        SERVICES_META_API_VERSION: 'Versión de la API de Meta (configuración del servidor)',
        SERVICES_META_AD_ACCOUNT_ID: 'Cuenta publicitaria de Meta (configuración del servidor)',
        SERVICES_META_PAGE_ID: 'Página de Facebook (configuración del servidor)',
        SERVICES_META_INSTAGRAM_USER_ID: 'Cuenta de Instagram (configuración del servidor)',
        SERVICES_META_ACCESS_TOKEN: 'Token de acceso de Meta (configuración del servidor)',
        SERVICES_META_APP_SECRET: 'Secreto de la app de Meta (configuración del servidor)',
        EFFECTS_META: 'Las llamadas a Meta están desactivadas en este entorno',
        ZONE_AD_SETTINGS_DSA_PAYOR: 'Quién paga el anuncio (DSA), en Ajustes',
        ZONE_AD_SETTINGS_DSA_BENEFICIARY: 'A quién beneficia el anuncio (DSA), en Ajustes',
      },

      IMBALANCE: {
        TITLE: 'Celdas con más conductores que pasajeros o al revés',
        SUB: 'Rutinas vigentes por celda H3: cada usuario cuenta en la celda de su origen y en la de su destino.',
        RESOLUTION: 'Resolución H3',
        RESOLUTION_OPTION: 'Resolución {{resolution}}',
        MIN_USERS: 'Mín. usuarios',
        MIN_USERS_INVALID: 'Pon un número entero desde 1.',
        SORT_LABEL: 'Orden',
        SORT: {
          ratio_desc: 'Más conductores por pasajero',
          ratio_asc: 'Más pasajeros por conductor',
          drivers_desc: 'Más conductores',
          riders_desc: 'Más pasajeros',
        },
        LIMIT: 'Celdas',
        LIMIT_OPTION: '{{count}} celdas',
        SEE_DRAFTS: 'Ver borradores',
        DRIVERS: 'Conductores',
        RIDERS: 'Pasajeros',
        TOTAL_SEATS: 'Plazas',
        AVERAGE_SEATS: 'Plazas por conductor',
        RATIO: 'Ratio',
        RATIO_HINT: 'Conductores ÷ (pasajeros + 1)',
        SEATS_RATIO: 'Ratio de plazas',
        SEATS_RATIO_HINT: 'Plazas ÷ (pasajeros + 1)',
        LACKING_ROLE: 'Falta',
        LACKING: {
          driver: 'Faltan conductores',
          rider: 'Faltan pasajeros',
          none: 'Equilibrada',
        },
        NO_LOCALITY: 'Sin localidad',
        LOAD_ERROR: 'No se ha podido cargar el informe de desequilibrio.',
        EMPTY: 'Ninguna celda llega al mínimo de usuarios.',
        SHOWING: 'Mostrando {{shown}} de {{total}} celdas',
        MAP_TOOLTIP: '{{drivers}} conductores · {{riders}} pasajeros',
        ZOOM_IN: 'Acercar',
        ZOOM_OUT: 'Alejar',
        CREATE_DRAFT: 'Crear borrador',
        CREATE_TITLE: 'Crear borrador de anuncio',
        ROLE_SUGGESTED: 'Según el informe: {{lacking}}.',
        OPTIONAL_TITLE: 'Valores del anuncio',
        OPTIONAL_HINT: 'Opcionales: lo que dejes vacío se toma de los ajustes de anuncios por zona.',
        FROM_SETTINGS: 'De los ajustes',
        ADVANTAGE_ON: 'Activada',
        ADVANTAGE_OFF: 'Desactivada',
        CREATE_SUBMIT: 'Crear borrador',
        CREATING: 'Creando…',
        CREATE_ERROR: 'No se ha podido crear el borrador.',
        OPEN_OCCUPIED: 'Ver el borrador abierto',
      },

      DRAFTS: {
        LIST_TITLE: 'Borradores de anuncios',
        LIST_SUB: 'Los genera el sistema o se crean desde el informe. Ábrelos para revisarlos, aprobarlos y publicarlos.',
        FROM_REPORT: 'Informe de desequilibrio',
        LOAD_ERROR: 'No se han podido cargar los borradores.',
        EMPTY: 'Todavía no hay borradores.',
        EMPTY_FILTERED: 'Ningún borrador cumple los filtros.',
        SHOWING: 'Mostrando {{shown}} de {{total}} borradores',
        PER_PAGE: '{{count}} por página',
        PER_PAGE_LABEL: 'Borradores por página',
      },

      DETAIL: {
        TITLE: 'Borrador de anuncio',
        BACK: 'Volver al listado',
        LOAD_NOT_FOUND: 'Este borrador no existe.',
        LOAD_FORBIDDEN: 'No tienes permiso para ver este borrador.',
        LOAD_FAILED: 'No se ha podido cargar el borrador.',
        RESOLUTION: 'Resolución {{resolution}}',
        APPROVED_AT: 'Aprobado',
        PUBLISHED_AT: 'Publicado',
        CLOSED_AT: 'Cerrado',
        ESTIMATED_SIGNUPS: 'Registros estimados',
        DECIDED_BY: 'Decidido por',
        REJECTED_REASON: 'Motivo del rechazo',

        PUBLISHING_TITLE: 'Publicando en Meta',
        PUBLISHING_TEXT: 'La campaña se está creando en segundo plano. Recarga en unos instantes para ver el resultado.',
        PUBLISH_ERROR_TITLE: 'La última publicación falló',

        READ_ONLY_TITLE: 'Solo se puede editar en borrador',
        READ_ONLY_TEXT: 'Una vez aprobado, el anuncio ya no cambia: lo que ves es lo que se publica.',
        AD_TITLE: 'Anuncio',
        AD_SUB: 'La plantilla pone la imagen y los textos; el nombre de la zona sustituye a su marcador.',
        TEMPLATE: 'Plantilla',
        TEMPLATE_HINT: 'Plantillas activas para {{role}}.',
        TEMPLATE_INACTIVE: '{{name}} (desactivada)',
        TEMPLATE_OTHER: 'Plantilla actual (no está en la lista)',
        TEMPLATES_ERROR: 'No se han podido cargar las plantillas.',
        ZONE_LABEL: 'Nombre de la zona',
        ZONE_LABEL_HINT: 'Como aparecerá en el anuncio, p. ej. «Sant Cugat».',
        AREA_TITLE: 'Área del anuncio',
        AREA_SUB: 'Círculo donde se muestra el anuncio y zonas que se excluyen dentro de él.',
        CENTER_LAT: 'Latitud del centro',
        CENTER_LONG: 'Longitud del centro',
        EXCLUSIONS: 'Exclusiones',
        EXCLUSIONS_HINT: 'Círculos donde no se muestra el anuncio. Como mucho {{max}}.',
        NO_EXCLUSIONS: 'Sin exclusiones.',
        ADD_EXCLUSION: 'Añadir exclusión',
        REMOVE_EXCLUSION: 'Quitar exclusión',
        EXCLUSION_OUTSIDE: 'Esta exclusión queda fuera del área del anuncio.',
        MAP_HINT: 'Arrastra el centro o el borde de un círculo para moverlo o cambiar su radio. Pulsa dentro del área para añadir una exclusión de 1 km.',
        MAP_MOVE: 'Arrastra para mover',
        MAP_RESIZE: 'Arrastra para cambiar el radio',
        ZOOM_IN: 'Acercar',
        ZOOM_OUT: 'Alejar',
        BUDGET_TITLE: 'Presupuesto y duración',
        BUDGET_SUB: 'Presupuesto total de la campaña y días que estará activa.',
        DISCARD: 'Descartar cambios',
        NO_CHANGES: 'No hay cambios que guardar',
        SAVED: 'Borrador guardado',
        SAVE_ERROR: 'No se ha podido guardar el borrador.',
        SAVE_FIRST: 'Guarda o descarta los cambios antes de aprobar',

        PREVIEW_TITLE: 'Vista previa',
        PREVIEW_SUB: 'Textos e imagen con el nombre de la zona puesto. Cambia al momento con el formulario, antes de guardar.',
        NO_TEMPLATE: 'Elige una plantilla para ver el anuncio.',
        SIGNUPS_TITLE: 'Registros atribuidos',
        SIGNUPS_SUB: 'Usuarios que llegaron desde este anuncio, según el rol de su primera rutina.',
        SIGNUPS_TOTAL: 'Total',
        SIGNUPS_NO_ROUTINE: 'Sin rutina',
        META_TITLE: 'Meta',
        META_SYNCED: 'Sincronizado el {{date}}.',
        META_NOT_SYNCED: 'Todavía sin métricas sincronizadas.',
        META_CAMPAIGN: 'Campaña',
        META_FACEBOOK_AD: 'Anuncio de Facebook',
        META_INSTAGRAM_AD: 'Anuncio de Instagram',
        META_FACEBOOK_STATUS: 'Estado en Facebook',
        META_INSTAGRAM_STATUS: 'Estado en Instagram',
        META_SPEND: 'Gastado',
        META_IMPRESSIONS: 'Impresiones',
        META_REACH: 'Alcance',
        META_CLICKS: 'Clics en el enlace',
        META_FEEDBACK: 'Revisión de Meta',

        APPROVE: 'Aprobar',
        APPROVE_TITLE: 'Aprobar el borrador',
        APPROVE_TEXT: 'Quedará listo para publicar y ya no se podrá editar.',
        APPROVING: 'Aprobando…',
        APPROVED: 'Aprobado',
        APPROVE_INCOMPLETE: 'Falta completar el borrador para aprobarlo',
        APPROVE_ERROR: 'No se ha podido aprobar el borrador',
        REJECT: 'Rechazar',
        REJECT_HINT: 'Cierra el borrador y lo deja en el historial: la zona espera el periodo de los ajustes antes de otro.',
        DELETE: 'Eliminar',
        DELETE_HINT: 'Lo borra para siempre, con sus rutinas. Solo se puede si nunca llegó a Meta.',
        DELETE_TITLE: 'Eliminar el borrador',
        DELETE_TEXT: 'Se borra para siempre, con sus rutinas. Si solo quieres que no se publique, recházalo.',
        DELETING: 'Eliminando…',
        DELETED: 'Eliminado',
        DELETE_ERROR: 'No se ha podido eliminar el borrador',
        REJECT_TITLE: 'Rechazar el borrador',
        REJECT_TEXT: 'Se cierra y no se publicará.',
        REJECT_TEXT_PUBLISHING: 'Se cierra. Lo que ya se haya creado en Meta se queda allí: no se pausa ni se borra.',
        REJECT_REASON: 'Motivo (opcional)',
        REJECTING: 'Rechazando…',
        REJECTED: 'Rechazado',
        REJECT_ERROR: 'No se ha podido rechazar el borrador',
        PUBLISH: 'Publicar en Meta',
        PUBLISH_RETRY: 'Reintentar publicación',
        PUBLISH_TITLE: 'Publicar en Meta',
        PUBLISH_TEXT: 'Se creará una campaña real con {{budget}} durante {{days}} días.',
        PUBLISHING: 'Enviando…',
        PUBLISH_QUEUED: 'En cola',
        PUBLISH_ERROR: 'No se ha podido publicar el borrador',
        META_NOT_CONFIGURED: 'Falta configurar la publicación en Meta',
        META_NOT_CONFIGURED_TEXT: 'Para publicar falta:',
        GO_TO_SETTINGS: 'Ir a ajustes',
      },

      TEMPLATES: {
        LIST_TITLE: 'Plantillas de anuncio',
        LIST_SUB: 'Imagen y textos de los anuncios. {{placeholder}} se sustituye por el nombre de la zona.',
        NEW: 'Nueva plantilla',
        NEW_TITLE: 'Nueva plantilla',
        EDIT_TITLE: 'Editar plantilla',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        CREATE: 'Crear plantilla',
        NAME: 'Nombre',
        NAME_HINT: 'Solo para el equipo; no sale en el anuncio.',
        ROLE_HINT: 'Solo se puede usar en borradores para el mismo destinatario.',
        HEADLINE: 'Título',
        PRIMARY_TEXT: 'Texto principal',
        PLACEHOLDER_HINT: 'Escribe {{placeholder}} donde vaya el nombre de la zona.',
        UNKNOWN_MARKERS: 'Estos marcadores no se sustituyen y saldrán tal cual en el anuncio: {{markers}}. El de la zona es {{placeholder}}.',
        IMAGE_URL: 'URL de la imagen',
        IMAGE_URL_HINT: 'Dirección https de una imagen ya publicada: no se suben archivos.',
        IMAGE_FAILED: 'No se ha podido cargar la imagen de esa dirección.',
        ACTIVE_LABEL: 'Activa (se puede elegir en los borradores)',
        STATE: 'Estado',
        ACTIVE: 'Activa',
        INACTIVE: 'Desactivada',
        LOAD_ERROR: 'No se han podido cargar las plantillas.',
        EMPTY: 'Todavía no hay plantillas.',
        SHOWING: 'Mostrando {{shown}} de {{total}} plantillas',
        PER_PAGE: '{{count}} por página',
        PER_PAGE_LABEL: 'Plantillas por página',
        CREATED: 'Plantilla creada',
        UPDATED: 'Plantilla guardada',
        SAVE_ERROR: 'No se ha podido guardar la plantilla.',
        IN_USE_ROLE: 'No se puede cambiar el destinatario: algún borrador usa esta plantilla.',
        DELETE_TITLE: 'Eliminar «{{name}}»',
        DELETE_TEXT: 'La plantilla desaparece. Si solo quieres que no se elija, desactívala.',
        DELETE_CONFIRM: 'Eliminar plantilla',
        DELETING: 'Eliminando…',
        DELETED: 'Eliminada',
        DELETE_ERROR: 'No se ha podido eliminar la plantilla',
        IN_USE_DELETE: 'Algún borrador la usa. Desactívala para que no se elija en borradores nuevos.',
      },
    },
  },
};
